<template>
  <div
    class="product-reviews"
  >
    <template v-if="REVIEWS.length">
      <div class="product-reviews__sort-wrap">
        <ui-select
          class="product-reviews__sort"
          :value="sortValue"
          :options="sortOptions"
          @change="sortChange"
        />
      </div>

      <product-user-review
        v-for="review in REVIEWS"
        :key="review.id"
        class="product-reviews__review"
        :id="review.id"
        :name="review.author.name"
        :date="createdDate(review.created_at)"
        :city="review.author.location"
        :rating="review.rating"
        :use-time="getUseTime(review)"
        :size="review.dimension"
        :pros="review.pros"
        :cons="review.cons"
        :text="review.body"
        :likes="review.likes"
        :dislikes="review.dislikes"
        :recommended="review.recommended"
        :comments="review.comments"
      />

      <div
        v-if="HAS_MORE"
        v-reached="loadMore"
        class="product-reviews__loader"
      >
        <transition name="fade">
          <ui-loader size="60" v-if="isReviewsLoading" />
        </transition>
      </div>
    </template>
    <template v-else>
      Никто не оставил отзывов по этому товару.
      Станьте первым
    </template>
  </div>
</template>

<script>
import ProductUserReview from './product-user-review.vue';
import { mapActions, mapGetters } from 'vuex';
import { ddmmyyyy } from '@/utils/date-to-string';
import { DEFAULT_REVIEW_SORT, NEW, OLD, RATING } from '@/store/consts';
import { productGtmEvents } from '@/gtm/product';

export default {
  name: "product-reviews",

  components: { ProductUserReview },

  props: {
    productCode: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      sortValue: DEFAULT_REVIEW_SORT,
      sortOptions: [
        {
          name: 'сначала новые',
          value: NEW,
        },
        {
          name: 'сначала старые',
          value: OLD,
        },
        {
          name: 'по оценке',
          value: RATING,
        },
      ],
      isReviewsLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      REVIEWS: 'product/productReviews',
      HAS_MORE: 'product/hasMoreReviewsPages',
    }),

    productId() {
      return this.$route?.params?.id;
    },
  },

  methods: {
    ...mapActions({
      loadMoreReviews: 'product/loadMoreReviews',
      loadProductReviews: 'product/loadProductReviews',
    }),

    sortChange({ value, name }) {
      this.sortValue = value;

      this.loadProductReviews({ productId: this.productId, sort: this.sortValue });

      productGtmEvents.reviews.changeSort({ name, productCode: this.productCode });
    },
    createdDate(date) {
      return ddmmyyyy(new Date(date));
    },
    async loadMore() {
      this.isReviewsLoading = true;
      await this.loadMoreReviews({ productId: this.productId, sort: this.sortValue });
      this.isReviewsLoading = false;
    },
    getUseTime(review) {
      return review.author?.details?.[0].value;
    },
  }
}
</script>

<style lang="scss">
  .product-reviews {
    &__sort-wrap {
      display: flex;
      justify-content: flex-end;
    }

    &__sort {
      margin-bottom: 36px;
      flex: 1 0 auto;

      @include breakpoint("tablet") {
        flex: 0 0 200px;
      }
    }

    &__review {
      margin-bottom: 32px;

      @include breakpoint("tablet") {
        margin-bottom: 24px;
      }

      @include breakpoint("desktop") {
        margin-bottom: 36px;
      }
    }

    &__loader {
      color: $blue;
      display: flex;
      justify-content: center;
    }
  }
</style>
